import { FC } from 'react';

import { DownloadOutlined } from '@ant-design/icons';
import { Button, theme, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { IExportContactsParams } from '@app/models/interfaces';
import { useLocalSelector } from '@app/services/hooks/useRedux';

import { useExportContactsQuery } from '../../../../hooks';

interface IProps {
  params: IExportContactsParams;
}

export const ExportButton: FC<IProps> = ({ params }) => {
  const { token } = theme.useToken();
  const contactsT = useTranslation(NSKeys.contacts);
  const currentSession = useLocalSelector((state) => state.currentSession);

  const { mutate, status } = useExportContactsQuery();

  if (!currentSession.dictionariesContext?.scope?.$permissions?.export_contacts) {
    return null;
  }

  return (
    <Tooltip placement="bottomLeft" title={contactsT.t('exportTooltip')}>
      <Button
        icon={<DownloadOutlined style={{ color: token.colorPrimary }} />}
        loading={status === 'loading'}
        onClick={() => mutate(params)}
      />
    </Tooltip>
  );
};
